import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/icons/breakfast.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/icons/game.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/icons/gym.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/icons/laundry.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/icons/light.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/icons/pool.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/icons/valet.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/icons/wifi.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/HeroImage.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/Room1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/Room2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/Room3.svg");
